import React from 'react'

import { omit, pick } from 'lodash'
import LongPressable from 'react-longpressable'

import { fal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isItemInactive } from 'utils/rules'

import('./Item.sass')

function Item(props) {
	const isOutside = isItemInactive(props)

	return (
		<div
			className={[
				'ItemWrapper',
				props.impact == 'medium' ? 'impactMedium' : '',
				props.impact == 'high' ? 'impactHigh' : '',
				props.y < -5 && !isOutside ? 'trendNegative' : '',
				props.y >= -5 && props.y <= 5 && !isOutside ? 'trendAtRisk' : '',
				props.y > 5 && !isOutside ? 'trendPositive' : '',
				isOutside ? 'trendAtRisk' : '',
				props.fade ? 'fade' : '',
			].join(' ')}
			{...pick(props, ['style', 'x', 'y', 'onMouseDown', 'onTouchStart'])}
		>
			<svg viewBox="-50 -50 100 100" className={'Item noselection ' + (props.selected ? 'selected' : '')}>
				<g>
					<circle
						className="selection"
						cx={0}
						cy={0}
						r={48}
						stroke="orange"
						strokeWidth={4}
						strokeDasharray="8 8"
						fill="none"
					></circle>
					<circle className="main" cx={0} cy={0} r={30}></circle>

					<FontAwesomeIcon
						x="-17.5"
						y="-18"
						width={35}
						height={35}
						color="black"
						icon={props.icon ? fal[props.icon] : fal['faUser']}
					></FontAwesomeIcon>
				</g>
			</svg>
			<div className="ItemText noselection">{props.name}</div>
		</div>
	)
}

export default Item
